import { defineStore } from 'pinia';
import api from '../../api';

export const useLogsStore = defineStore('logs', {
  state: () => ({
    logsData: [],
    logsDataUpdated: false,
    loggingCfg: {},
    loggingCfgUpdated: false
  }),

  actions: {
    queryLogs() {
      return api.logs.queryLogs()
        .then(data => {
          if(data?.resp?.respCode == 0){
            this.setLogging(data.loggingCfg)
          }
          return data;
        })
        .catch(error => {
          throw error;
        });
    },
    setLogging(data){
      this.loggingCfg = data;
      this.loggingCfgUpdated = true;
    },
    setLogs(params) {
      return api.logs.setLogs(params)
        .then(data => {
          return data;
        })
        .catch(error => {
          throw error;
        });
    },

    getLogList(params) {
      return api.logs.getLogList(params)
        .then(data => {
          this.setLogsData(data);
          return data;
        })
        .catch(error => {
          throw error;
        });
    },
    setLogsData(data){
      this.logsData = data;
      this.logsDataUpdated = true;
    },

    clearLogs() {
      return api.logs.clearLogs()
        .then(data => {
          return data;
        })
        .catch(error => {
          throw error;
        });
    },
  }
});
